import { createContext } from 'react';

const GtmFilterContext = createContext({
  gtmFilter: {},
  setGtmFilter: (g) => {}
});

export default GtmFilterContext;